import React from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Button,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";

import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import {
  getCurrencyCode,
  getFullName,
} from "../../../../../helpers/CommonHelper";

const Details = ({ item, moduleConfig }) => {
  const fields = moduleConfig.fields;
  const paymentDone = item.status === "1";
  return (
    <>
      <Card className="item  mb-2">
        <Card.Header className="ps-1 pe-2 py-0">
          <Card.Title className="m-0 p-0 ">
            <div className="d-flex ImageSectionSpacing">
              <div className="position-relative ms-1 me-2">
                <div className="ms-1 me-2">
                  <i
                    className={`fas fa-${
                      item.status === "1"
                        ? "thumbs-up text-success"
                        : "thumbs-down text-warning"
                    }  position-relative usericon `}
                  ></i>
                </div>
              </div>
              <div className="d-flex flex-column ms-1">
                <span className="m-0 text-bold memberName ">
                  <Link
                    to={
                      item.purpose === "Product Order"
                        ? `/customers/${item?.order?.customer?._id}`
                        : `/customers/${item?.subscription?.customer?._id}`
                    }
                    className="text-red"
                    title="Please click to view customer details"
                    variant="link"
                  >
                    {item.purpose === "Product Order"
                      ? item?.order?.customer?.fullName
                      : item?.subscription?.customer?.fullName}
                  </Link>
                </span>
                <span className="text-bold text-custom-4 small fs-8 mt-1 ">
                  {item?.purpose}
                </span>
              </div>
            </div>
          </Card.Title>

          <div className="card-tools">
            <div className=" text-right  mt-1">
              <span className="badge badge-light me-1 text-dark">
                Payment Date:{" "}
                <span className="text-secondary">{item.createdAt}</span>
              </span>
            </div>
          </div>
        </Card.Header>

        <Card.Body className="p-1">
          <Table bordered striped hover responsive size="sm" className="m-0">
            <tbody>
              {item.orderId && (
                <tr>
                  <td>Order ID</td>
                  <td>
                    <Link to={`/orders/${item.orderId}`}>
                      {item.orderId}
                    </Link>{" "}
                  </td>
                </tr>
              )}
              {item.subscriptionId && (
                <tr>
                  <td>Subscription ID</td>
                  <td>
                    <Link to={`/subscriptions/${item.subscriptionId}`}>
                      {item.subscriptionId}
                    </Link>{" "}
                  </td>
                </tr>
              )}
              {/* {item.cartId && (
              <tr>
                <td>Cart ID</td>
                <td>{item.cartId}</td>
              </tr>
            )} */}
              {item.stripePaymentId && (
                <tr>
                  <td>Stripe Payment ID</td>
                  <td>{item.stripePaymentId}</td>
                </tr>
              )}
              {item.stripeSessionId && (
                <tr>
                  <td>Stripe Session ID</td>
                  <td>{item.stripeSessionId}</td>
                </tr>
              )}
              {/* {item.purpose && (
                <tr>
                  <td>Purpose</td>
                  <td>{item.purpose}</td>
                </tr>
              )} */}

              {/* <tr>
                <td>Customer</td>
                <td>
                  <Link
                    to={
                      item.purpose === "Product Order"
                        ? `/customers/${item?.order?.customer?._id}`
                        : `/customers/${item?.subscription?.customer?._id}`
                    }
                    className="fw-semibold text-decoration-none text-custom-3"
                  >
                    {item.purpose === "Product Order"
                      ? item?.order?.customer?.fullName
                      : item?.subscription?.customer?.fullName}
                  </Link>
                </td>
              </tr> */}
              {item?.subscription?.specialDiscountAmount?.$numberDecimal >
                0 && (
                <tr>
                  <td>Special Discount</td>
                  <td>
                    {item?.subscription?.specialDiscountAmount.$numberDecimal}{" "}
                    {getCurrencyCode()}
                  </td>
                </tr>
              )}
              {item.subTotal && (
                <tr>
                  <td>Subtotal</td>
                  <td>
                    {item.subTotal} {getCurrencyCode()}
                  </td>
                </tr>
              )}

              {item.vatAmount && (
                <tr>
                  <td>VAT</td>
                  <td>
                    {item.vatAmount} {getCurrencyCode()}
                  </td>
                </tr>
              )}

              {item.shippingCharges > 0 && (
                <tr>
                  <td>Shipping Charges</td>
                  <td>
                    {item.shippingCharges} {getCurrencyCode()}
                  </td>
                </tr>
              )}
              {item.purpose === "Meal Subscription" &&
                item.depositAmount?.$numberDecimal && (
                  <tr>
                    <td>Deposit Amount</td>
                    <td>
                      {item.depositAmount?.$numberDecimal} {getCurrencyCode()}
                      {(item.depositAmountFromPreviousSubscription === "1" ||
                        item.depositAmountFromPreviousSubscription === 1) && (
                        <Alert className="small p-1 mb-0" variant="success">
                          The deposit amount has been carried forward from the
                          previous subscription upon renewal.
                        </Alert>
                      )}
                    </td>
                  </tr>
                )}
              {item.totalAmount && (
                <tr>
                  <td>Total Amount</td>
                  <td>
                    <strong>
                      {item.totalAmount} {getCurrencyCode()}
                    </strong>
                  </td>
                </tr>
              )}

              {item.paidAmount && (
                <tr>
                  <td>{paymentDone ? "Paid Amount" : "Payable Amount"}</td>
                  <td>
                    <strong
                      className={paymentDone ? "text-success" : "text-danger"}
                    >
                      {item.paidAmount} {getCurrencyCode()}
                    </strong>
                  </td>
                </tr>
              )}

              {item.date && (
                <tr>
                  <td>Payment Date</td>
                  <td>{item.date}</td>
                </tr>
              )}

              {/* {item.updatedAt && (
              <tr>
                <td>Last Updated</td>
                <td>
                  <ModuleDisplayDateTime value={item.updatedAt} />
                </td>
              </tr>
            )} */}

              {item.adminComments && (
                <tr>
                  <td>Admin Comments</td>
                  <td>{item.adminComments}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};

export default Details;
